angular.module('gym.calendar').directive('eventScheduleRestrictions', function() {
  return {
    restrict: 'E',
    template: require('templates/gyms/calendar/events/edit_event_schedule/restrictions/event_schedule_restrictions.html.slim'),
    scope: {
      gym: '=',
      event: '=',
      permissions: '=',
      classrooms: '=',
      eventTypes: '=',
      styles: '=',
      onEdit: '&',
      cancelEdit: '&',
      save: '&'
    },
    controller: ["$scope", "$modal", "isInteger", function($scope, $modal, isInteger) {
      var gymBookingDetail, setNewInstructorModal;
      gymBookingDetail = $scope.gym.gym_booking_detail;
      $scope.$watch('event', function(newVal) {
        var ref;
        if (newVal == null) {
          return;
        }
        return $scope.isZeroBookingEvent = (ref = newVal.participant_limit) === 0 || ref === (void 0) || ref === null;
      });
      $scope.getWaitlistLimit = function() {
        if (isInteger($scope.event.waitlist_limit)) {
          return `limit: ${$scope.event.waitlist_limit}`;
        } else {
          return 'no limit';
        }
      };
      setNewInstructorModal = function(eventCopy, classrooms, eventTypes, styles, save) {
        return $modal.open({
          template: require('templates/gyms/calendar/events/edit_event_schedule/edit_event_no_instructors_modal.html.slim'),
          controller: ["$scope", "$modalInstance", function($scope, $modalInstance) {
            $scope.cancel = function() {
              return $modalInstance.dismiss('cancel');
            };
            return $scope.editEventGeneral = function() {
              $scope.cancel();
              return $modal.open({
                template: require('templates/gyms/calendar/events/edit_event_schedule/general/edit_event_schedule_general.html.slim'),
                windowClass: 'drawer__wrapper',
                backdropClass: 'modal-backdrop--drawer',
                controller: 'EditEventScheduleGeneralCtrl',
                resolve: {
                  params: function() {
                    return {
                      event: eventCopy,
                      save: save,
                      classrooms: classrooms,
                      styles: styles,
                      eventTypes: eventTypes,
                      cancelEdit: $scope.cancel
                    };
                  }
                }
              });
            };
          }]
        });
      };
      return $scope.edit = function() {
        var eventCopy;
        eventCopy = $scope.event.clone();
        if (!eventCopy.instructor_ids.length) {
          setNewInstructorModal(eventCopy, $scope.classrooms, $scope.eventTypes, $scope.styles, $scope.save);
          return;
        }
        eventCopy.cancel_before_number || (eventCopy.cancel_before_number = gymBookingDetail.cancel_before_number_default || 1);
        eventCopy.cancel_before_unit || (eventCopy.cancel_before_unit = gymBookingDetail.cancel_before_unit_default || 'day');
        eventCopy.bookings_allowed_before_number || (eventCopy.bookings_allowed_before_number = gymBookingDetail.bookings_allowed_before_number_default || 1);
        eventCopy.bookings_allowed_before_unit || (eventCopy.bookings_allowed_before_unit = gymBookingDetail.bookings_allowed_before_unit_default || 'day');
        eventCopy.bookings_allowed_after_number || (eventCopy.bookings_allowed_after_number = gymBookingDetail.bookings_allowed_after_number_default || 1);
        eventCopy.bookings_allowed_after_unit || (eventCopy.bookings_allowed_after_unit = gymBookingDetail.bookings_allowed_after_unit_default || 'hour');
        eventCopy.event_types_join_attributes = eventCopy.event_schedule_event_types.map(function(item) {
          return {
            id: item.event_type_id,
            participant_limit: isInteger(item.participant_limit) ? item.participant_limit : null
          };
        });
        $scope.onEdit();
        return $modal.open({
          template: require('templates/gyms/calendar/events/edit_event_schedule/restrictions/edit_event_schedule_restrictions.html.slim'),
          windowClass: 'drawer__wrapper',
          backdropClass: 'modal-backdrop--drawer',
          controller: 'EditEventScheduleRestrictionsCtrl',
          resolve: {
            params: function() {
              return {
                event: eventCopy,
                save: $scope.save,
                cancelEdit: $scope.cancelEdit
              };
            }
          }
        });
      };
    }]
  };
});
